export default {"src":"/_next/static/media/SENCO-SHAPE-OF-YOU-FULL_2.0c592d16.gif","height":648,"width":1080};